<template>
    <div class="container">
        <container :active_path="path" :plate="'云项目'">
            <div class="base-warp">
                <div class="head">
                    <el-form label-width="80px" :inline="true" size="mini">
                        <el-form-item label="客户姓名">
                            <el-input v-model="keyword" placeholder="请输入客户姓名"></el-input>
                        </el-form-item>
                        <el-form-item label="手机号">
                            <el-input v-model="telephone" placeholder="请输入客户手机号"></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
                            <el-button type="warning" icon="el-icon-s-data" plain @click="$router.push({path: '/project/client/statics'})">统计图</el-button>
                            <el-button type="primary" icon="el-icon-plus" plain @click="$store.commit('setaddclientpicker', true)">添加客户</el-button>
                        </el-form-item>
                    </el-form>
                </div>
                <div class="table-box">
                    <el-table 
                    :data="tabledata"
                    border 
                    size="mini"
                    :header-cell-style="{background:'#f7f7f7',color:'#999', textAlign: 'center', fontWeight: 'normal'}">
                        <el-table-column type="index" label="序号" align="center" width="60"></el-table-column>
                        <el-table-column prop="source" label="来源" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="name" label="客户名称" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="tel" label="电话" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="wechart" label="微信" show-overflow-tooltip></el-table-column>
                        <!-- <el-table-column prop="job" label="职务" show-overflow-tooltip></el-table-column> -->
                        <!-- <el-table-column prop="mold" label="板块" show-overflow-tooltip></el-table-column> -->
                        <!-- <el-table-column prop="enterprise" label="企业" show-overflow-tooltip></el-table-column> -->
                        <!-- <el-table-column prop="cname" label="名称" show-overflow-tooltip></el-table-column> -->
                        <el-table-column prop="need" label="商户需求" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="showdate" label="添加日期" show-overflow-tooltip></el-table-column>
                    </el-table>
                </div>
                <el-pagination class="page-tion"
                    @current-change="currentChange"
                    layout="prev, pager, next"
                    :page-size="pagesize"
                    :total="total" background>
                </el-pagination>
            </div>
        </container>

        <add-client></add-client>
        <router-view></router-view>
    </div>
</template>

<script>
import AddClient from '../../../components/client/add-client.vue';
import container from '../../../components/container.vue'
export default {
    components: { container, AddClient },
    data() {
        return {
            path: '/project/client',
            keyword: '',
            telephone: '',
            pageNo: 1,
            pagesize: 20,
            total: 0,
            tabledata: [],
        }
    },
    mounted () {
        this.gettabledata();
    },
    methods: {
        search() {
            this.pageNo = 1;
            this.gettabledata();
        },
        currentChange(page) {
            this.pageNo = page;
            this.gettabledata();
        },
        gettabledata() {
            var params = {
                keyword: this.keyword,
                telephone: this.telephone,
                pageNo: this.pageNo,
                pagesize: this.pagesize,
            }
            this.$api.getClientsListForProject(params).then(
                data=>{
                    let {list, total} = data;
                    this.tabledata = list;
                    this.total = total;
                }
            )
        },
    },
}
</script>

<style lang="scss" scoped>

</style>